import React from 'react';
import { Truck, ShieldCheck, Sparkles, Heart } from 'lucide-react';

const items = [
  { icon: Truck, title: 'Ücretsiz Kargo', desc: '500₺ üzeri alışverişlerde' },
  { icon: ShieldCheck, title: 'Güvenli Alışveriş', desc: 'İade ve değişim garantili' },
  { icon: Sparkles, title: 'Özel Tasarım', desc: 'Sınırlı sayıda üretim' },
  { icon: Heart, title: 'Özenle Hazırlanır', desc: 'El emeği detaylar' },
];

export default function Features() {
  return (
    <section className="bg-[#f0e9df] py-14 border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {items.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="flex items-start gap-4">
            <div className="h-11 w-11 flex items-center justify-center border border-stone-300 rounded-full text-stone-800 bg-[#f7f2ec]">
              <Icon className="h-4 w-4" />
            </div>
            <div>
              <div className="font-serif text-lg text-stone-900">{title}</div>
              <div className="mt-0.5 text-[13px] text-stone-600">{desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
